// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const documentTemplateId = (z.number());
export const documentTemplate = z.object({
    id: documentTemplateId,
    name: z.string(),
    created_at: z.date().nullable(),
    created_by: operatorId.nullable(),
    share_code: z.string(),
});
export const documentTemplateInitializer = z.object({
    id: documentTemplateId.optional(),
    name: z.string(),
    created_at: z.date().optional().nullable(),
    created_by: operatorId.optional().nullable(),
    share_code: z.string().optional(),
});
export const documentTemplateMutator = z.object({
    id: documentTemplateId.optional(),
    name: z.string().optional(),
    created_at: z.date().optional().nullable(),
    created_by: operatorId.optional().nullable(),
    share_code: z.string().optional(),
});
//# sourceMappingURL=DocumentTemplate.js.map